<template>
  <div>
    <div v-if="dataPage.route == 'accueil'" class="accueil">
      <div id="header">
        <header
          class="bg-bf col-12 d-lg-flex d-none flex-row justify-content-between align-items-center"
        >
          <div
            class="info-menu py-2 d-flex flex-row justify-content-center align-items-center"
          >
            <img src="@/../public/elements/pin.png" alt="map" />
            <a href="#" class="c-g pl-3"
              >362 rue de la République<br />76230 Bois-Guillaume</a
            >
          </div>
          <!-- <div
            class="info-menu py-2 d-flex flex-row justify-content-center align-items-center"
          >
            <img src="@/../public/elements/icone-clock.png" alt="horaires" />
            <a href="#" class="c-g pl-3"
              >Lundi, Mardi, Vendredi de 9h à 12h et de 14h à 18h<br />Fermé le Mercredi / Jeudi et Samedi de 9h à 12h </a
            >
          </div> -->
          <div
            class="info-menu py-2 d-flex flex-row justify-content-center align-items-center"
          >
            <img src="@/../public/elements/phone-grey.png" alt="tel" />
            <div class="tel d-flex flex-column pl-3">
              <a href="contact" class="rdv c-w mb-0 p-0">Prendre</a>
              <a href="contact" class="num c-w mt-0">Rendez-vous</a>
            </div>
          </div>
        </header>

        <!-- MENU MOBILE -->

        <div id="mobile-header" class="bg d-lg-none">
           <router-link
            tag="a"
            to="accueil"
          >
          <img
            class="mobile-logo"
            src="@/../public/elements/logo-cbgr.png"
            alt="logo"
          />
          </router-link>
          <div class="mobile-btn bg-bf">
            <button
              class="d-lg-none navbar-toggler toggler-example"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent1"
              aria-controls="navbarSupportedContent1"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <img id="menu-ham" src="@/../public/elements/menu.png" alt="" />
            </button>
          </div>
        </div>

        <div
          class="collapse navbar-collapse bg-bf"
          id="navbarSupportedContent1"
        >
          <!-- MENU MOBILE OPENED -->
          <ul class="navbar-nav mr-auto">
            <ul>
              <li
                class="nav-item"
                v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu
                  .children"
                :key="index"
              >
                <a
                  :href="menu.route"
                  class="py-2 c-w text-uppercase"
                  >{{ menu.labelMenu }}</a
                >
              </li>
            </ul>
          </ul>
        </div>

        <!-- Exemple Import d'un element en SVG Dynamic Color <icone-map height="28px" :color="color1" /> -->
        <v-style>
          /* Use CustomerVar with example : {{ customizableVar1 }}
          Set Background Image with example :
          background-image:url('\{\{require('@/html/elements/after-page-title-0f555d.svg')}}')
          !important; */
        </v-style>
      </div>
    </div>
    <div v-else >
      <header>
        <nav class="navbar navbar-expand-lg d-none d-lg-flex">
          <router-link
            tag="a"
            to="accueil" class="navbar-brand ml-4" 
            ><img src="@/../public/elements/logo.png" alt="logo"
          /></router-link>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav pt-1">
             <li
                class="nav-item"
                v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu
                  .children"
                :key="index"
              >
                <router-link
                  tag="a"
                  :to="menu.route"
                  class="nav-link c-w"
                  >{{ menu.labelMenu }}</router-link
                >
              </li>
            </ul>
            <a href="contact" id="pr-rdv" class="d-none d-lg-flex flex-column bg-w">
              <p class="c-bf mb-0 mt-1">PRENDRE</p>
              <p class="c-bf mb-1">Rendez-vous</p>
            </a>
          </div>
        </nav>

        <div id="mobile-header" class="bg d-lg-none">
          <router-link
            tag="a"
            to="accueil"
            >
            <img
              class="mobile-logo"
              src="@/../public/elements/logo-cbgr.svg"
              alt="logo"
            />
          </router-link>
          <div class="mobile-btn bg-bf">
            <button
              class="d-lg-none navbar-toggler toggler-example"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent1"
              aria-controls="navbarSupportedContent1"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <img id="menu-ham" src="@/../public/elements/menu.png" alt="" />
            </button>
          </div>
        </div>

        <div
          class="collapse navbar-collapse bg-bf"
          id="navbarSupportedContent1"
        >
          <!-- MENU MOBILE OPENED -->
          <ul class="navbar-nav contenu mr-auto">
            <ul>
              <li
                class="nav-item"
                v-for="(menu, index) of $parent.dataIris.menuHeader.itemsMenu
                  .children"
                :key="index"
              >
                <a
                  :href="menu.route"
                  class="py-2 c-w text-uppercase"
                   
                  >{{ menu.labelMenu }}</a
                >
              </li>
            </ul>
          </ul>
        </div>
      </header>
    </div>
  </div>
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

/*  
Exemple Import d'un element en SVG :
import IconeClock from "../html/elements/lt-icone-clock.vue";
*/

export default {
  name: "espHeader",
  components: {
    // Exemple Import d'un element en SVG : ajouter ici : IconeClock,
  },
  props: {
    dataPage: {
      type: Object,
    },
    dataIris: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    color1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
    color2: function () {
      if (this.dataIris.customizableVar[1].value) {
        return this.dataIris.customizableVar[1].value;
      } else {
        return "0f555d";
      }
    },
    customizableVar1: function () {
      if (this.dataIris.customizableVar[0].value) {
        return this.dataIris.customizableVar[0].value;
      } else {
        return "0f555d";
      }
    },
  },
  created() {},
  methods: {
    chartStringBr(val) {
      return val.replace(" ", "<br>");
    },
  },
};
</script>
